module.exports = __webpack_public_path__ + "static/img/BR.85e32d85.png";